import { CustomerProfile } from 'consts';

const defaultProfileSettings: CustomerProfile = {
  showCookieBanner: true,
  applicationPrefix: 'NetLine',
  applicationName: 'WorkSpace',
};

export default defaultProfileSettings;
